import React from 'react'
import { MuiThemeProvider } from '@material-ui/core'
import { primaryTheme } from '../themes'

export const PrimaryThemeProvider = ({ children }) => (
  <MuiThemeProvider theme={primaryTheme}>{children}</MuiThemeProvider>
)
